import React from 'react';
import { Modal } from '@app/shared/ui/organisms/Common';
import { cn } from '@app/shared/utils/common';

interface GlassModalProps {
  isOpen: boolean;
  onOpenChange: () => void;
  children: React.ReactNode;
  isShadow?: boolean;
  className?: string;
}

export function GlassModal({
  isOpen,
  onOpenChange,
  children,
  isShadow = true,
  className,
}: GlassModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      overlayClassName="backdrop-blur-sm"
      contentClassName={cn(
        'bg-secondary-foreground/40 rounded-3xl p-2 max-w-[420px]',
        isShadow && 'shadow-blue',
        className
      )}
      displayCloseButton={false}
      hiddenTitle="Modal"
    >
      {children}
    </Modal>
  );
}
